const styles = {
  info: {
    color: "info.main",
    fontSize: 12,
  },
};

export default styles;
